import { connect } from 'react-redux';
import ArtifactsMetricsHunterSelectorComponent
  from '../Components/ArtifactsMetricsHunterSelectorComponent';
import { setArtifactsInfo } from './../actions';
import {
  artifactsMetricsPageReducer,
  getCaseMetricsArtifactGroups,
  getCaseMetricsArtifactHunters,
} from './../reducers';

export const mapStateToProps = (state) => {
  const artifactsInfo = artifactsMetricsPageReducer.getArtifactsInfo(state);
  const hunterGroups = getCaseMetricsArtifactGroups(state);
  const hunters = getCaseMetricsArtifactHunters(state);

  return {
    artifactsInfo,
    availableGroups: hunterGroups || [],
    availableHunters: hunters || []
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onSelectorChange: (artifactsInfo) =>
      dispatch(setArtifactsInfo(artifactsInfo))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactsMetricsHunterSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactsMetricsHunterSelectorContainer.jsx